"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrdersMapper = void 0;
const lodash_1 = __importDefault(require("lodash"));
class OrdersMapper {
    toDomain(result) {
        const hasError = !!lodash_1.default.get(result, "error");
        const isOrdersLoading = lodash_1.default.get(result, "loading");
        const orders = [
            ...lodash_1.default.get(result, "data.active.edges"),
            ...lodash_1.default.get(result, "data.recent.edges"),
        ].map((o) => (Object.assign(Object.assign({}, o.node), { __typename: "Order" })));
        return {
            hasError,
            isOrdersLoading,
            orders,
        };
    }
}
exports.OrdersMapper = OrdersMapper;
